import React, { Component } from 'react'
import { connect } from 'react-redux'
// import * as actions from '../../actions'
import { FormHelpers, formatName } from '../../helpers'
import PlayerForm from './PlayerForm'
import * as actions from '../../actions'

class ManagePlayer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      profile: {
        pref: 'Mr',
        name: '',
        cover: '/imgs/header.png',
        avatar: '/imgs/default-avatar.jpg',
        handle: '',
        my_skills: '',
        interests: [],
        social_accounts: [],
        share_with_us: '',
        team: ''
      }
    }

    this.handleUserChange = this.handleUserChange.bind(this)
    this.handleRoleChange = this.handleRoleChange.bind(this)
    this.handleArrayChange = this.handleArrayChange.bind(this)
    this.addArrayElement = this.addArrayElement.bind(this)
    this.removeArrayElement = this.removeArrayElement.bind(this)
    this.removeParticipant = this.removeParticipant.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.checkButtonsArea = this.checkButtonsArea.bind(this)
    this.setImageToState = this.setImageToState.bind(this)
  }

  // componentDidMount () {
  //   this.props.participantId && this.props.dispatch(actions.getParticipant(this.props.participantId))
  // }

  componentDidMount () {
    let { myTeam, players, participantId } = this.props
    if (JSON.stringify(players) !== '[]') {
      const index = players.findIndex(p => p.id === participantId)
      let newProfile = {
        ...this.state.profile,
        ...players[index],
        pref: players[index].name.split(' ')[0],
        name: formatName(players[index].name),
        cover: myTeam.cover || '/imgs/header.png'
      }
      this.setState({ profile: newProfile })
    }
  }

  checkButtonsArea (event) {
    if (event.which === 13 && !event.shiftKey) {
      event.preventDefault()
      this.addArrayElement(event.target.name)
    }
  }

  handleUserChange (event) {
    FormHelpers.handleFormChange.bind(this)(event, 'profile')
  }

  handleRoleChange (id, ev) {
    let roles = { ...this.state.myTeam.roles }
    roles[id] = ev.target.value
    const myTeam = { ...this.state.myTeam, roles: roles }
    this.setState({ myTeam: myTeam })
  }

  handleArrayChange (arr, index, ev) {
    let arrClone = [...this.state.profile[arr]]
    arrClone[index] = ev.target.value
    let profile = { ...this.state.profile }
    profile[arr] = arrClone
    this.setState({ profile: profile })
  }

  addArrayElement (arr) {
    let arrClone = [...this.state.profile[arr]]
    arrClone.push('')
    let newProfile = { ...this.state.profile }
    newProfile[arr] = arrClone
    this.setState({ profile: newProfile })
  }

  removeArrayElement (arr, index, id) {
    let arrClone = [...this.state.profile[arr]]
    arrClone.splice(index, 1)
    let profile = { ...this.state.profile }
    profile[arr] = arrClone
    this.setState({ profile: profile })
  }

  removeParticipant (p) {
    const index = this.state.myTeam.participants.indexOf(p)
    this.removeArrayElement('participants', index, p._id)
  }

  handleSubmit () {
    const { profile } = this.state
    if (profile.name === '' || profile.my_skills === '') {
      this.props.dispatch(actions.displayAlert('Missing field(s).'))
      return
    }

    profile.name = profile.pref + ' ' + profile.name

    let { myTeam, players, participantId } = this.props
    const index = players.findIndex(p => p.id === participantId)
    let oldProfile = {
      ...players[index],
      pref: players[index].name.split(' ')[0],
      cover: myTeam.cover || '/imgs/header.png'
    }

    const diff = Object.keys(profile).reduce((diff, key) => {
      if (oldProfile[key] === profile[key]) return diff
      return {
        ...diff,
        [key]: profile[key]
      }
    }, {})

    if (JSON.stringify(diff) === '{}') {
      this.props.dispatch(actions.displayAlert('Nothing to save.'))
      return
    }

    JSON.stringify(diff) !== '{}' && this.props.dispatch(actions.playerManage(diff))
  }

  setImageToState (type, url) {
    let newProfile = { ...this.state.profile }
    newProfile[type] = url
    this.setState({ profile: newProfile })
  }

  render () {
    return (
      <PlayerForm
        onChange={this.handleUserChange}
        setImage={this.setImageToState}
        roleChange={this.handleRoleChange}
        arrayChange={this.handleArrayChange}
        addElement={this.addArrayElement}
        removeElement={this.removeArrayElement}
        removeParticipant={this.removeParticipant}
        checkButtonsArea={this.checkButtonsArea}
        onSubmit={this.handleSubmit}
        {...this.state.profile} />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    myTeam: state.team.myTeam,
    players: state.participants,
    participantId: state.auth.user.participantId
  }
}

export default connect(mapStateToProps)(ManagePlayer)



// WEBPACK FOOTER //
// ./src/screens/player/ManagePlayer.js